import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addItem: {
    id: 'sku-add-item-form.add-item',
    defaultMessage: 'Add item',
  },
  itemNameLabel: {
    id: 'sku-add-item-form.label.item-name',
    defaultMessage: 'Item name',
  },
  itemNamePlaceholder: {
    id: 'sku-add-item-form.placeholder.item-name',
    defaultMessage: 'E.g. "Berry Smoothie"',
  },
  itemDescriptionLabel: {
    id: 'sku-add-item-form.label.item-description',
    defaultMessage: 'Item description',
  },
  itemDescriptionPlaceholder: {
    id: 'sku-add-item-form.placeholder.item-description',
    defaultMessage: 'E.g. "Seasonal berry smoothie. Contains soy and tree nuts."',
  },
  categoryLabel: {
    id: 'sku-add-item-form.label.category',
    defaultMessage: 'Select categories',
  },
  selectCategory: {
    id: 'sku-add-item-form.select-category',
    defaultMessage: 'Select categories',
  },
  priceVerificationInfo: {
    id: 'sku-add-item-form.info.price-verification',
    defaultMessage: 'We must verify the price of this item before it becomes available to order.',
  },
  addCategory: {
    id: 'sku-add-item-form.add-category',
    defaultMessage: '+ Add category',
  },
  addCategoryLabel: {
    id: 'sku-add-item-form.add-category-label',
    defaultMessage: 'Add category',
  },
  loadingCategories: {
    id: 'sku-add-item-form.loading-categories',
    defaultMessage: 'Loading categories...',
  },
  menuPriceLabel: {
    id: 'sku-add-item-form.label.menu-price',
    defaultMessage: 'Menu price',
  },
  taxExcludedMenuPriceDescription: {
    id: 'sku-add-item-form.description.menu-price-tax-excluded',
    defaultMessage: "The price on your menu, not including tax. We'll use this to calculate your payout.",
  },
  taxIncludedMenuPriceDescription: {
    id: 'sku-add-item-form.description.menu-price-tax-included',
    defaultMessage: "The price on your menu, including tax. We'll use this to calculate your payout.",
  },
  linkToMenuLabel: {
    id: 'sku-add-item-form.label.link-to-menu',
    defaultMessage: 'Link to menu',
  },
  linkToMenuPlaceholder: {
    id: 'sku-add-item-form.placeholder.link-to-menu',
    defaultMessage: 'https://www.example.com/menu',
  },
  linkToMenuDescription: {
    id: 'sku-add-item-form.description.link-to-menu',
    defaultMessage: 'Required for price verification.',
  },
  cancelButton: {
    id: 'sku-add-item-form.button.cancel',
    defaultMessage: 'Cancel',
  },
  submitButton: {
    id: 'sku-add-item-form.button.submit',
    defaultMessage: 'Submit for review',
  },
  invalidUrl: {
    id: 'sku-add-item-form.errors.invalid-url',
    defaultMessage: 'Please enter a valid link.',
  },
  categoryRequired: {
    id: 'sku-add-item-form.errors.category-required',
    defaultMessage: 'Please select at least one category.',
  },
  priceRequired: {
    id: 'sku-add-item-form.errors.price-required',
    defaultMessage: 'Menu price is required.',
  },
  priceMustBePositive: {
    id: 'sku-add-item-form.errors.price-must-be-positive',
    defaultMessage: 'Menu price must be greater than zero.',
  },
  errorAddItem: {
    id: 'sku-add-item-form.errors.add-item',
    defaultMessage: '<strong>We were unable to add your item</strong>',
  },
  successAddItem: {
    id: 'sku-add-item-form.success.add-item',
    defaultMessage: '<strong>{itemName}</strong> was successfully added and is now in review.',
  },
  formSubmitError: {
    id: 'sku-add-item-form.errors.form-submit-error',
    defaultMessage:
      'Oops! We were unable to submit your item. Please make sure you filled out all required fields correctly.',
  },
});
